/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Mark_ReviewedInputs */

const en_recipe_mark_reviewed = /** @type {(inputs: Recipe_Mark_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark reviewed`)
};

const de_recipe_mark_reviewed = /** @type {(inputs: Recipe_Mark_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als geprüft markieren`)
};

/**
* | output |
* | --- |
* | "Mark reviewed" |
*
* @param {Recipe_Mark_ReviewedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_mark_reviewed = /** @type {((inputs?: Recipe_Mark_ReviewedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Mark_ReviewedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_mark_reviewed(inputs)
	return en_recipe_mark_reviewed(inputs)
});